import {
  startLoading
} from '@/plugins/loading'
import http from '@/plugins/api'
import * as types from './types'

export default {
  /**
   * Get all users by location
   * @param {Object} params - SearchOptions object
   */
  async getUsersByLocation({
    rootState,
    commit,
    dispatch
  }, params) {
    // Remove object reactivity
    params = JSON.parse(JSON.stringify(params))

    // Set market segments by default (used on Upsert User) or assigned the ones selected in the search area (used on Location List)
    if (typeof params.marketSegments !== 'undefined') {
      params.marketSegments = `[${params.marketSegments.join()}]`
    } else {
      params.marketSegments = `[${rootState.video.marketSegments.map(item => item.id).join()}]`
    }

    // Call API
    const r = await startLoading(dispatch, 'getUsersByLocation', () =>
      http.get(`users/getbylocation`, {
        params
      })
    )

    commit(types.SET_USERS, r.data.items)
    return r.data.count
  },
  /**
   * Get roles based on user
   */
  async getRoles({
    commit,
    dispatch
  }) {
    // Call API
    const r = await startLoading(dispatch, 'getRoles', () =>
      http.post(`users/getRoles`)
    )

    commit(types.SET_ROLES, r.data)
    return r.data.count
  },
  /**
   * Create a new user
   * @param {Object} user - User's data
   */
  async createUser({
    commit,
    dispatch
  }, user) {
    // Convert additional emails array into comma-delimiter string
    if (user.additionalEmailsArray.length > 0) {
      user.additionalEmails = user.additionalEmailsArray.map((ae) => ae.email).join(',')
    }

    // Call API
    const r = await startLoading(dispatch, 'createUser', () =>
      http.post('users/create', user)
    )

    // Note: If there's no data, it means that the user already exists
    if (r.data !== '') {
      commit(types.ADD_USER, r.data)
      user.additionalEmails = null
    } else {
      throw new Error('We found an existing user with the email address provided.')
    }

    return r.data
  },
  /**
   * Update an existing user
   * @param {Object} user - User's data
   */
  async updateUser({
    dispatch
  }, user) {
    // Convert additional emails array into comma-delimiter string
    if (user.additionalEmailsArray.length > 0) {
      user.additionalEmails = user.additionalEmailsArray.map((ae) => ae.email).join(',')
    }

    // Call API
    const r = await startLoading(dispatch, 'updateUser', () =>
      http.post(`users/update`, user)
    )

    // Note: If there's no data, it means that the user already exists
    if (r.data === -1) {
      throw new Error('We found an existing user with the email address provided.')
    }
    if (r.data === 0) {
      throw new Error('There was an error updating the user.')
    } else {
      return r.data
    }
  },
  /**
   * Delete an existing user
   * @param {Object} user - User's data
   */
  async deleteUser({
    commit,
    dispatch
  }, user) {
    // Call API
    const r = await startLoading(dispatch, 'deleteUser', () =>
      http.post(`users/delete`, {
        id: user.id
      })
    )

    commit(types.DELETE_USER, user)
    return r.data
  },
  /**
   * Get a user
   * @param {Number} userID - User's ID
   */
  async getUser({
    dispatch
  }, userID) {
    // Call API
    const r = await startLoading(dispatch, 'getUser', () =>
      http.get(`users/get?id=${userID}`)
    )
    if (r.data !== '') {
      return r.data
    } else {
      throw new Error('User not found.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js